import styled from 'styled-components';

export const LinksStyled = styled.p`
  padding: 0.5rem;
  text-align: center;
`;

export const Link = styled.a``;
